export default __webpack_public_path__ + "4d07f5cc90dc4b7a6f35bb694596b27b.svg";